// import { analyticsEvent } from './analytics';
import { createOptions, share } from './share';
import { getResultImageGenerator } from './utils/resultImageGenerator';
import { getResultImg, uploadResultImg } from './api';

// UTILS:
const objToGetParams = (data) => Object.keys(data)
    .map((key) => `${key}=${encodeURIComponent(data[key])}`)
    .join('&');

const shareResult = (social, options, imageUrl) => {
    const finalOptions = createOptions(options);

    if (imageUrl) {
        finalOptions.image = imageUrl;
        finalOptions.media = imageUrl;
        finalOptions.url += ((finalOptions.url.indexOf('?') > -1 ? '&' : '?') + objToGetParams({
            t: 'result',
            img: encodeURIComponent(imageUrl)
        }));
    }

    console.log(finalOptions);

    share(social, finalOptions);
};

const registerListener = (btn, options) => {
    const { social } = btn.dataset;

    if (!social) return;

    btn.addEventListener('click', async () => {
        document.body.classList.add('share-result-loading');

        const generator = getResultImageGenerator();
        const score = generator.value;

        getResultImg(score).then((data) => {
            const { publicUrl: imgUrl } = data;

            console.log('getting img...');

            shareResult(social, options, imgUrl);
        }, () => {
            const bitmap = generator.getBlob();

            console.log(bitmap);

            uploadResultImg(bitmap, score).then((data) => {
                const { publicUrl: imgUrl } = data;

                console.log('uoloading img...');

                shareResult(social, options, imgUrl);
            }, (err) => {
                console.warn(`Fail to construct result image to share (${err}). Default image is to be shared`);
                shareResult(social, options);
            });
        });

        document.body.classList.remove('share-result-loading');

        // analyticsEvent('Results page', 'Click', 'Share');
    });
};

export const initShareButtons = (selector, options = {}) => {
    const btns = [...document.querySelectorAll(selector)];

    btns.forEach((btn) => {
        registerListener(btn, options);
    });
};
